var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/path.js
// module id = 33
// module chunks = 49